<script>
    import InfiniteLoading from 'vue-infinite-loading'
    import GiftCourseItem from './GiftCourseItem.vue'
    import GiftItemsSearchForm from './GiftItemsSearchForm'
    import {Form} from '../../helpers/Form/Form'

    export default {
        props: {
            source: String,
            payments: {
                type: Boolean,
                default: false
            },
            startAuto: false,
            coursePerPage: {
                type: Number,
                default: 30
            }
        },
        components: {InfiniteLoading, GiftCourseItem, GiftItemsSearchForm},
        data() {
            return {
                infiniteId: +new Date(),
                items: [],
                pagination: {},
                remainingItems: 0,
                form: new Form({
                    page: 1,
                    municipality: '',
                    sport: '',
                    age: '',
                    payments: this.payments,
                    perPage: 30
                })
            }
        },
        created() {
            if (this.coursePerPage)
                this.$set(this.form, 'perPage', this.coursePerPage);

            this.$bus.$on('update', this.updateItems);
        },
        mounted() {
            if (this.startAuto) {
                this.infiniteHandler();
            }
        },
        methods: {
            infiniteHandler($state = null) {
                if (!_.isEmpty(this.pagination)) {
                    if (this.pagination.current_page === this.pagination.last_page) {
                        if ($state)
                            $state.complete()
                    } else {
                        this.fetch($state)
                    }
                } else {
                    this.fetch($state)
                }
            },
            fetch($state = null) {
                this.form
                    .get(this.source, {}, true)
                    .then(({courses}) => {
                        if (courses.total > 0) {
                            let temp = this.items;

                            this.$set(this.form, 'page', courses.current_page + 1);
                            this.$set(this, 'pagination', _.omit(courses, ['data']));
                            this.$set(this, 'items', temp.concat(courses.data));
                            this.remainingItems = courses.total - courses.to;
                            if ($state)
                                $state.loaded();

                            if (this.pagination.total === this.form.perPage) {
                                if ($state)
                                    $state.complete()
                            }
                            if (this.pagination.current_page === this.pagination.last_page) {
                                if ($state)
                                    $state.complete()
                            }
                        } else {
                            if ($state)
                                $state.complete()
                        }
                    })
            },
            updateItems({params}) {
                console.log(params);
                for (let key in params) {
                    if (this.form.hasOwnProperty(key) && params[key]) {
                        this.$set(this.form, key, params[key])
                    }
                }

                this.$set(this, 'pagination', {})
                this.form.page = 1;
                this.items = [];
                if (this.startAuto) {
                    this.infiniteHandler();
                }
                else {
                    this.infiniteId += 1;
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/gift/GiftItemsContainer.vue